import React, {Component} from "react";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Tab from "@material-ui/core/Tab/Tab";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Map from "../common/Map/Map";
import Three from "../common/Three/Three";
import Info from "../desktop/Info/Info";
import PropTypes from 'prop-types';
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import IconButton from "@material-ui/core/IconButton/IconButton";
import InfoIcon from "@material-ui/icons/Info"
import InfoDialog from "./InfoDialog/InfoDialog";
import {MobileWrapper, SwipeableViewsContainer, Title} from "./Mobile.sc";
import {GenerateProgress} from "../desktop/Desktop.sc";

class Mobile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: 0,
            dialogOpen: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeIndex = this.handleChangeIndex.bind(this);
        this.handleInfoDialogOpen = this.handleInfoDialogOpen.bind(this);
        this.handleInfoDialogClose = this.handleInfoDialogClose.bind(this);
    }

    handleChange(event, value) {
        this.setState({
            value
        })
    }

    handleChangeIndex(value) {
        this.setState({
            value
        });
    }

    handleInfoDialogOpen() {
        this.setState({
            dialogOpen: true
        })
    }

    handleInfoDialogClose() {
        this.setState({
            dialogOpen: false
        })
    }

    render() {
        const {
            lat, lng, boxSize, boxScale, waterDrop, baseHeight, verticalScale, modelScale,
            loadingComplete, model, zoom, handleBaseHeightChange, handleBoxScaleChange, handleBoxSizeChange,
            handleLocationChange, handleVerticalScaleChange, handleWaterDropChange, handleModelScaleChange,
            onBoxChange, onClickGenerate, onClickDownload, showDownloadButton
        } = this.props;

        const {value, dialogOpen} = this.state;

        return (
            <MobileWrapper>
                <AppBar position="static" color="default">
                    <Toolbar>
                        <Title variant="title" color="inherit">
                            map2STL.com
                        </Title>
                        <IconButton
                            onClick={this.handleInfoDialogOpen}>
                            <InfoIcon/>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <AppBar position={"static"}>
                    <Tabs
                        value={value}
                        onChange={this.handleChange}
                        fullWidth
                    >
                        <Tab label={"Map"}/>
                        <Tab label={"Model"}/>
                        <Tab label={"Settings"}/>
                    </Tabs>
                </AppBar>
                {!loadingComplete && <GenerateProgress/>}
                <SwipeableViewsContainer
                    index={value}
                    onChangeIndex={this.handleChangeIndex}
                    containerStyle={{height: 'calc(100% - 56px - 48px)'}}
                >
                    <Map
                        onBoxChanged={(lat, lng) => onBoxChange(lat, lng, boxSize, boxScale)}
                        lat={lat}
                        lng={lng}
                        defaultZoom={zoom}
                        boxSize={boxSize}
                        boxScale={boxScale}
                    />
                    <Three
                        model={model}
                        showLegalWrapper={false}
                    />
                    <Info
                        verticalScale={verticalScale}
                        baseHeight={baseHeight}
                        waterDrop={waterDrop}
                        handleOnClickGenerate={onClickGenerate}
                        handleOnClickDownload={onClickDownload}
                        handleBoxSizeChange={handleBoxSizeChange}
                        handleLocationChange={handleLocationChange}
                        handleBoxScaleChange={handleBoxScaleChange}
                        handleWaterDropChange={handleWaterDropChange}
                        handleBaseHeightChange={handleBaseHeightChange}
                        handleVerticalScaleChange={handleVerticalScaleChange}
                        handleModelScaleChange={handleModelScaleChange}
                        lat={lat}
                        lng={lng}
                        modelScale={modelScale}
                        boxSize={boxSize}
                        boxScale={boxScale}
                        downloadAvailable={typeof model !== 'undefined'}
                        loadingComplete={loadingComplete}
                        showDownloadButton={showDownloadButton}
                    />
                </SwipeableViewsContainer>
                <InfoDialog open={dialogOpen} onClose={this.handleInfoDialogClose}/>
            </MobileWrapper>
        )
    }

}

Mobile.propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    boxSize: PropTypes.number.isRequired,
    boxScale: PropTypes.number.isRequired,
    waterDrop: PropTypes.number.isRequired,
    baseHeight: PropTypes.number.isRequired,
    verticalScale: PropTypes.number.isRequired,
    modelScale: PropTypes.number.isRequired,
    loadingComplete: PropTypes.bool.isRequired,

    model: PropTypes.object,
    zoom: PropTypes.number.isRequired,

    handleBaseHeightChange: PropTypes.func.isRequired,
    handleBoxScaleChange: PropTypes.func.isRequired,
    handleBoxSizeChange: PropTypes.func.isRequired,
    handleLocationChange: PropTypes.func.isRequired,
    handleVerticalScaleChange: PropTypes.func.isRequired,
    handleWaterDropChange: PropTypes.func.isRequired,
    handleModelScaleChange: PropTypes.func.isRequired,
    onBoxChange: PropTypes.func.isRequired,
    onClickGenerate: PropTypes.func.isRequired,
    onClickDownload: PropTypes.func.isRequired,
    showDownloadButton: PropTypes.bool.isRequired
};

export default Mobile;



// WEBPACK FOOTER //
// ./src/mobile/Mobile.js